// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a7f662c2","703":"e9e0389c"}[chunkId] + ".chunk.js";
};